import React, { useState } from "react";
import {
  getFieldDate,
  getFieldFormattedValue,
  getFieldName,
  getFieldText,
  formatDate,
} from "../scripts/helperScripts";
import DiagnosisCard from "./common/DiagnosisCard";
import DiagnosisModal from "./common/DiagnosisModal";

function DiagnosisEntity({
  clientId,
  diagnosis,
  selectedProgram,
  showExpired,
  updateDiagnosis,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [dx, setDx] = useState({});

  //Set diagnosis/detail object and show modal
  const showModal = (diagnosis) => {
    const dxObj = {
      ccx_clientdiagnosisid: getFieldText(diagnosis.ccx_clientdiagnosis),
      clientDiagnosisName: getFieldName(diagnosis.ccx_clientdiagnosis),
      ccx_clientdiagnosisdetailid: diagnosis.ccx_clientdiagnosisdetailid,
      ccx_clientprogram: getFieldText(diagnosis.ccx_clientprogram),
      clientprogramName: getFieldName(diagnosis.ccx_clientprogram),
      ccx_diagnosistype: getFieldFormattedValue(diagnosis.ccx_diagnosistype),
      ccx_effdate: formatDate(getFieldDate(diagnosis.ccx_effdate)),
      ccx_expdate: formatDate(getFieldDate(diagnosis.ccx_expdate)),
      ccx_name: diagnosis.ccx_name,
      ccx_presentonadmissionos: getFieldFormattedValue(
        diagnosis.ccx_presentonadmissionos
      ),
      ccx_rank: getFieldFormattedValue(diagnosis.ccx_rank),
      ccx_reasonforaction: getFieldFormattedValue(
        diagnosis.ccx_reasonforaction
      ),
      ccx_code: diagnosis["dx.ccx_code"],
      sor_notes: diagnosis.sor_notes,
      dxccx_diagnosingprovider: getFieldName(
        diagnosis["dx.ccx_diagnosingprovider"]
      ),
      ccx_diagnosiscategory: getFieldName(
        diagnosis["dx.ccx_diagnosiscategory"]
      ),
      dxccx_diagnosistype: getFieldName(diagnosis["dx.ccx_diagnosistype"]),
      ccx_dsm5: getFieldName(diagnosis["dx.ccx_dsm5"]),
      dxccx_effdate: formatDate(getFieldDate(diagnosis["dx.ccx_effdate"])),
      dxccx_expdate: formatDate(getFieldDate(diagnosis["dx.ccx_expdate"])),
      dxccx_name: diagnosis["dx.ccxname"],
      dxccx_presentonadmission: getFieldName(
        diagnosis["dx.ccx_presentonadmission"]
      ),
      dxccx_sourceofdata: getFieldName(diagnosis["dx.ccx_sourceofdata"]),
    };
    setDx(dxObj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setDx(null);
    setIsOpen(true);
  };

  return (
    <>
      <DiagnosisModal
        isOpen={isOpen}
        hideModal={hideModal}
        clientId={clientId}
        clientProgram={selectedProgram}
        initialData={dx}
        updateDiagnosis={updateDiagnosis}
      ></DiagnosisModal>
      {/* <ClientDialogButton title="Add Diagnosis" contactID={clientId} /> */}
      <button className="btn btn-primary" onClick={addNew}>
        Add Diagnosis
      </button>
      <br />
      <div className="row row-cols-1">
        {diagnosis
          ? diagnosis
              .filter(
                (dx) =>
                  getFieldText(dx.ccx_clientprogram) ===
                  selectedProgram.ccx_client_programid
              )
              .map((dx) => (
                <div
                  className={
                    dx.ccx_expdate === undefined &&
                    dx["dx.ccx_expdate"] === undefined &&
                    !showExpired
                      ? "d-block p-2"
                      : dx.ccx_expdate !== undefined && showExpired
                      ? "d-block p-2"
                      : dx["dx.ccx_expdate"] !== undefined && showExpired
                      ? "d-block p-2"
                      : "d-none p-2"
                  }
                  key={dx.ccx_clientdiagnosisdetailid}
                >
                  <DiagnosisCard dx={dx} showEdit={showModal} />
                </div>
              ))
          : "No Client Diagnosis Details"}
      </div>
    </>
  );
}

export default DiagnosisEntity;
